import { RouteRecordRaw } from 'vue-router';
import {
  HomePage,
  FilteredListPage,
  ModuleMatrixRevisionPage,
  QualityRecordMatrixPage,
} from '@/pages/home';

export const routeName = 'Home';

export const route: RouteRecordRaw = {
  path: '',
  name: routeName,
  component: HomePage,
  meta: {
    requiresAuth: true,
  },
  children: [
    {
      path: 'registros-da-qualidade/:prefix',
      name: 'QualityRecordMatrix',
      component: QualityRecordMatrixPage,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: 'revisao-da-matriz/:folderCode',
      name: 'ModuleMatrixRevision',
      component: ModuleMatrixRevisionPage,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: ':itemName*',
      name: 'FilteredList',
      component: FilteredListPage,
      meta: {
        requiresAuth: true,
        breadcrumb: 'Listagem Filtrada',
      },
    },
  ],
};
